import clsx from "clsx";
import React, { FunctionComponent, ReactNode } from "react";

import { RoundButton } from "../Button/Button";
import { CrossIcon } from "../icons/CrossIcon";

type DialogHeaderProps = {
  className?: string;
  headingClassName?: string;
  onClose: VoidFunction | null;
  subtitle?: ReactNode;
  title: ReactNode;
};

export const DialogHeader: FunctionComponent<DialogHeaderProps> = ({
  className,
  headingClassName = "text-xl",
  onClose,
  subtitle,
  title,
}) => {
  return (
    <header className={clsx("flex px-4 pt-6 items-start", className)}>
      <div className="flex-1 leading-2">
        <h2 className={headingClassName}>{title}</h2>
        {subtitle && <h3 className="text-sm">{subtitle}</h3>}
      </div>
      {onClose && (
        <RoundButton
          aria-label="closeDialog"
          className="w-9 h-9 text-xl hidden sm:flex"
          onClick={onClose}
        >
          <CrossIcon />
        </RoundButton>
      )}
    </header>
  );
};
